import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { PostOrderGroupRequest } from '@/coreInfrastructureModule/axios/generated/orderGroupManage';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';
import { IOrderGroup } from '../../coreDomainsModule/entities/IOrderGroup';
import { OrderGroupAdapter } from '../adapters/OrderGroupAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 発注グループを作成する
 */
export class PostOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 発注グループを作成する
   * @param request - 発注グループ
   * @returns 作成された発注グループID
   */
  public execute = async (request: IOrderGroup): Promise<INetworkResult<string | undefined, IError>> => {
    const adaptedRequest: PostOrderGroupRequest = OrderGroupAdapter.adaptPostOrderGroup(request);
    try {
      const networkResult = await this.repository.postOrderGroup(adaptedRequest);
      switch (networkResult.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: networkResult.status.data.orderGroupId,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: networkResult.status.error,
            },
          };
        default:
          throw new Error();
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: -1,
            code: 'unknown',
            message: '想定外のエラー',
          },
        },
      };
    }
  };
}
